/**
 * 获取当前站点的完整 origin (e.g., https://www.kilimall.co.ke)
 * 兼容 SSR (useRequestHeaders) 和客户端 (window.location)
 */
export const useCurrentHost = (): string => {
  if (process.server) {
    const headers = useRequestHeaders()
    const requestUrl = useRequestURL()
    const proto = headers['x-forwarded-proto'] || requestUrl.protocol.replace(':', '') || 'https'
    return `${proto}://${headers.host || requestUrl.host || 'www.kilimall.co.ke'}`
  }
  return `${window.location.protocol}//${window.location.host}`
}
